import React from "react";
import { useTranslation } from 'react-i18next';

function LegendBox() {
  const {t} = useTranslation();
  return (
    <div className="legend-dropdown" style={{ position: "absolute", left: "-200px" }}>
      <p className="leg-title">{t('LEGEND')}</p>
      <ul className="legend-lists">
        <li>{t('Average OKR progress across teams')}</li>
        <li>
          <div className="above_rep"></div>
          <div className="legend-list-text">{t('Above Plan')}</div>
        </li>
        <li>
          <div className="onplan_rep"></div>
          <div className="legend-list-text">{t('On Plan')}</div>
        </li>
        <li>
          <div className="medium_rep"></div>
          <div className="legend-list-text">{t('Medium Risk')}</div>
        </li>
        <li>
          <div className="risk_rep"></div>
          <div className="legend-list-text">{t('At Risk')}</div>
        </li>
        <li>
          <div className="nookr_rep"></div>
          <div className="legend-list-text">{t('No OKRs set')}</div>
        </li>
        <a
          className="leg-learnMore"
          href="https://workboard.zendesk.com/hc/en-us/articles/360034662431"
          target="_blank"
        >
          {t('Learn more')}
        </a>
      </ul>
    </div>
  );
}
export default LegendBox;
